import React, { useState } from "react";
import { Link } from "react-router-dom";
import { List, ListItemButton, ListItemText, Menu } from "@mui/material";
import { AngleIcon } from "../../Icons";

const HeaderAttract = () => {
  const [headerMenuEl, setHeaderMenuEl] = useState(null);
  const headerMenuOpen = Boolean(headerMenuEl);
  const headerMenuOpenReq = (event) => {
    setHeaderMenuEl(event.currentTarget);
  };
  const headerMenuClose = () => {
    setHeaderMenuEl(null);
  };

  return (
    <>
      <div
        className={`managepro6ix-layout-header-right-item-btn managepro6ix-layout-header-right-item-btn-full ${
          headerMenuOpen ? "active" : ""
        }`}
        id="header-attract-menu-button"
        aria-controls={headerMenuOpen ? "header-attract-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={headerMenuOpen ? "true" : undefined}
        onClick={headerMenuOpenReq}
      >
        <div className="managepro6ix-layout-header-right-item-btn-text">
          Attract Capital
        </div>
        {headerMenuOpen ? <AngleIcon up /> : <AngleIcon small />}
      </div>

      <Menu
        id="header-attract-menu"
        anchorEl={headerMenuEl}
        open={headerMenuOpen}
        onClose={headerMenuClose}
        MenuListProps={{
          "aria-labelledby": "header-attract-menu-button",
        }}
        className="managepro6ix-layout-header-right-item-dropdown managepro6ix-layout-header-right-item-dropdown-users"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <List
          component="nav"
          className="managepro6ix-layout-header-right-item-dropdown-users-list"
        >
          <ListItemButton
            className="managepro6ix-layout-header-right-item-dropdown-users-list-item"
            component={Link}
            to="https://leads.6ix.com"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-right-item-dropdown-users-list-item-text"
              primary="Get Leads"
            />
          </ListItemButton>

          <ListItemButton
            className="managepro6ix-layout-header-right-item-dropdown-users-list-item"
            component={Link}
            to="https://events.6ix.com/create"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-right-item-dropdown-users-list-item-text"
              primary="Host Events"
            />
          </ListItemButton>
          <ListItemButton
            className="managepro6ix-layout-header-right-item-dropdown-users-list-item"
            component={Link}
            to="https://meetings.6ix.com"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-right-item-dropdown-users-list-item-text"
              primary="Schedule Meetings"
            />
          </ListItemButton>
        </List>
      </Menu>
    </>
  );
};

export default HeaderAttract;
